import authConfig from "emun.auth/auth.config"; //get shared
import basicController from "servicestack/basic.controller.properties";
import resetPasswordPrompt from "emun.auth/reset-password/reset-password-prompt";
import loginPrompt from "emun.auth/login-prompt";
import actionList from "webmodals/action-list";
import modals from "webmodals/modals";

export default class VerifyEmailSimpleController {
  constructor($scope) {
    basicController(this);
    const $ctrl = this;
    $ctrl.bus = $ctrl.$session.bus;
    delete $ctrl.bus.validationErrors;
    $ctrl.config = authConfig;
  }

  queryRegistrationEmails() {
    const $ctrl = this;
    const { request = {}, email } = $ctrl;
    return $ctrl.bus
      .read(`QueryRegistrationEmails/${email || request.email}`)
      .then(({ data }) => {
        if (data.length) {
          const [retailerId] = data;
          request.retailerId = retailerId;
        }
      });
  }

  gotoRegistration() {
    const $ctrl = this;
    location.href = $ctrl.registrationUrl + "?email=" + $ctrl.email;
  }

  gotoLogin() {
    const $ctrl = this;
    location.href = $ctrl.loginUrl + "?email=" + $ctrl.email;
  }

  onEmailExists() {
    const $ctrl = this;
    var emailExistsActions = {};
    $ctrl.retailers.map(r => {
      emailExistsActions["Register" + r.id] = {
          title: r.companyName,
          icon: "envelope",
          body: `<span>${r.companyName}</br>${r.address}</br>${r.city}</br>${r.state}</br>${r.zip}</span>`,
          handler: () => {
            $ctrl.requestAccess(r);
          }
      };
    })
    return actionList({
      title: $ctrl.config.emailExistsTitle,
      body: $ctrl.config.emailExistsMessage($ctrl.$session),
      actions: emailExistsActions,
      size: "md"
    }).then((a) => {
      a.handler();
    });
  }

  onEmailNotFound() {
    const $ctrl = this;
    var emailNotFoundActions = {
      "Go to Registration": {
        icon: "user",
        body: "Register for an account",
        handler: () => {
          $ctrl.gotoRegistration();
        },
      },
    };
    return actionList({
      title: "Email address not found",
      body: $ctrl.config.emailNotFoundMessage,
      actions: emailNotFoundActions,
      size: "md"
    }).then((a) => {
      a.handler();
    });
  }
  onUserExists() {
    const $ctrl = this;
    const userExistsActions = {
      "Go to Login": {
        icon: "user",
        body: "Enter credentials to login to the system",
        handler: () => {
          $ctrl.login();
        },
      },
      "Reset Password": {
        icon: "lock",
        body: "Having trouble logging in?  Let's reset your password",
        handler: function () {
          $ctrl.resetPassword();
        },
      },
    };
    return actionList({
      title: "Email address is already registered",
      body: $ctrl.config.userExistsMessage,
      actions: userExistsActions,
      size: "md",
    }).then((a) => {
      a.handler();
    });
}

requestAccess(r) {
  const $ctrl = this;
  $ctrl.bus.send("RequestSiteAccess.json", {
    Email: $ctrl.email,
    RetailerId: r.id,
    CompanyName: r.companyName,
    Address: r.address,
    City: r.city,
    State: r.state,
    Zip: r.zip
  }).then(res => {
    modals.alert($ctrl.config.siteAccessMessage($ctrl.$session));
  });
}

  submit() {
    const $ctrl = this;
    delete $ctrl.user;
    delete $ctrl.retailer;
    delete $ctrl.retailers;
    $ctrl.bus
      .read(`QueryUserEmail.json`, { email: $ctrl.email })
      .then(({ data }) => {
        if (data.results.length) {
          $ctrl.user = data.results[0];
          $ctrl.processed = true;
          $ctrl.onUserExists();
        } else {
          //OTP
          if ($ctrl.config.useOneTimePasscode) {
            return $ctrl.$session
            .requestOneTimePasscode($ctrl.email, {
              usePrompt: true,
              login: false,
            })
            .then(() => {
              $ctrl.checkRegistrationEmails();
            });
          } else {
            $ctrl.checkRegistrationEmails();
          }
        }
      });
  }

  checkRegistrationEmails() {
    const $ctrl = this;
    $ctrl.bus
    .read(`QueryRetailersByEmail/${$ctrl.email}`)
    .then((res) => {
      if (res.data.retailers.length) {
        $ctrl.retailers = res.data.retailers;
        $ctrl.onEmailExists();
      } else {
        $ctrl.onEmailNotFound();
      }
      $ctrl.processed = true;
    })

  }

  login() {
    let $ctrl = this;
    $ctrl.$dismiss && $ctrl.$dismiss("login");
    return loginPrompt({ email: $ctrl.email});
  }

  resetPassword() {
    let $ctrl = this;
    //return resetPasswordPrompt({ email: $ctrl.email });
    return $ctrl.bus.send(`ResetPassword.json`, {
      email: $ctrl.email
    }).then(
      res => {
        // alert("Please check your email to reset your password");
        $ctrl.$dismiss && $ctrl.$dismiss("resetPassword", res.data);
        $notify.success("Please check your email to reset your password", {
          title: "Reset Password",
          ttl: 5000,
          disableCountDown: true
        });
      },
      failed => {
        // alert("This email address is not on file in our system");
        // $ctrl.onFail && $ctrl.onFail(failed.data.responseStatus);
        // $ctrl.errors = failed.data.responseStatus;
      }
    );
  }

  setFocus(id) {
    let $ctrl = this;
    setTimeout(function () {
      var element = window.document.getElementById(id);
      if (element) {
        element.focus();
      }
    }, 500);
  }
}
